// extracted by mini-css-extract-plugin
module.exports = {"container":"CSVError-module__container--mAxHL","textDanger":"CSVError-module__textDanger--31iAi","iconDanger":"CSVError-module__iconDanger--fhFqk"};